import { getRegional } from "library/getRegional";
import { getDataLayer } from "library/tealiumUtils";
import initTealiumTracker from "tealium-tracker";
import { TrackingData } from "./types";

const siteData = {
  page: {
    site: "lfs-lsc",
    siteCountry: getRegional("code")?.toLowerCase() || "au",
  },
  user: {
    authenticationStatus: "not logged in",
    profile: {
      emailAddress: "",
      profileId: "",
      customerMasterId: "",
    },
  },
};
const tealiumTracker = initTealiumTracker({
  // schema, // TODO: Add later
  debugMode: localStorage.getItem("tealiumDebugMode") === "true",
});

export const trackingConfig = {
  siteData,
  eventTracking: {
    trackEvent: (data: TrackingData): void => {
      tealiumTracker.trackEvent(getDataLayer(data));
    },
    getQueryString: ({ pageData, eventData }) => {
      const details = {
        site: siteData.page.site,
        siteSection: pageData?.page.siteSection,
        siteSubSection: pageData?.page.siteSubSection,
        pageTitle: pageData?.page.pageTitle,
        buttonName: eventData?.event.label,
        location: eventData?.event.location,
      };

      // filter out the empty or undefined variables to clean up the query string
      return `gemid2=${Object.keys(details)
        .filter((item) => Boolean(details[item]))
        .map((key) => encodeURIComponent(details[key]))
        .join(":")}`;
    },
  },
  pageTracking: {
    trackPageView: (data: TrackingData): void => {
      tealiumTracker.trackPageLoad(getDataLayer(data));
    },
  },
};
